import React, { Component, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { Home } from "./pages/Home";
import { VerifyResetPin } from "./pages/VerifyResetPin";
import { GoogleForm } from './pages/GoogleForm';

export const App = () =>{
  return <div>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/verify_reset_pin" element={<VerifyResetPin />}></Route>
        <Route path="/form" element={<GoogleForm />}></Route>
      </Routes>
    </BrowserRouter>
  </div>
}
